import { isNumber } from 'lodash';
import { computed } from 'mobx';

import { sessionStore } from 'stores';

import { time } from 'utils';

import { generateDistancePrice } from '../utils/priceUtils/generateDistancePrice';

import { changeDistanceStore } from '../stores';

import { distanceSelector } from './mappedData';

const normalizeEmail = (email: string | nil): string => (email || '').trim().toLowerCase();

export const changeDistanceConditions = {
  isChangeDistance: computed((): boolean => Boolean(changeDistanceStore.token)),

  errorCode: computed((): string | null => changeDistanceStore.errorCode),

  deadline: computed((): string | null => {
    const expiresAt = changeDistanceStore.details?.expires_at;

    if (!expiresAt || !time.isValid(expiresAt, 'datetime')) {
      return null;
    }

    return time.datetime(expiresAt).parseFromBe().formatAsString('shortDateWithTime');
  }),

  sourceDistanceName: computed((): string | null => changeDistanceStore.details?.from_distance.name || null),

  targetDistanceName: computed((): string | null => changeDistanceStore.details?.to_distance.name || null),

  racerEmail: computed((): string | null => changeDistanceStore.details?.racer_email || null),

  signedInEmail: computed((): string | null => (sessionStore.isAuth ? sessionStore.getUserData().email || null : null)),

  isEmailMismatch: computed((): boolean => {
    const racerEmail = changeDistanceConditions.racerEmail.get();
    const signedInEmail = changeDistanceConditions.signedInEmail.get();

    if (!racerEmail || !signedInEmail) {
      return false;
    }

    return normalizeEmail(racerEmail) !== normalizeEmail(signedInEmail);
  }),

  isDowngrade: computed((): boolean => {
    const paidPrice = changeDistanceStore.details?.paid_price;
    const distance = distanceSelector.model.get();

    if (!distance) {
      return false;
    }

    const targetPrice = generateDistancePrice(distance);

    return isNumber(paidPrice) && isNumber(targetPrice) && paidPrice > targetPrice;
  }),
};
